import { render, staticRenderFns } from "./saModal.vue?vue&type=template&id=a4d664e2"
import script from "./saModal.vue?vue&type=script&lang=js"
export * from "./saModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports